/* Enum to determine if something can be deleted
 * @enum {number}
 */
export enum CanDeleteEnum {
  'QUERYING',
  'TRUE',
  'FALSE',
}
